<template>
  <div>
    <v-card elevation="0" class="pb-2 rounded-lg">
      <div class="pa-4">
        <div class="d-flex justify-space-between align-center mb-2">
          <h5 class="ma-0">Funcionalidades</h5>
          <v-btn color="primary" small @click="openDialog()">
            <v-icon small left>mdi-plus</v-icon>
            Nova funcionalidade
          </v-btn>
        </div>

        <v-alert v-if="error" type="error" class="mb-3">
          {{ error }}
        </v-alert>

        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          label="Pesquisar"
          single-line
          dense
          hide-details
          outlined
          class="mb-3"
        />

        <v-data-table
          :loading="loading"
          :items="features"
          :headers="headers"
          :search="search"
          class="elevation-0"
        >
          <template v-slot:item.title="{ item }">
            <v-icon small class="mr-2">
              {{ item.icon || "mdi-chevron-double-right" }}
            </v-icon>
              {{ item.title }}
          </template>
          <template v-slot:item.status="{ item }">
            <v-chip small label dark :color="statusColor(item.status)">
              {{ statusText(item.status) }}
            </v-chip>
          </template>
          <template v-slot:item.public="{ item }">
            <v-icon small :color="item.public ? 'success' : 'grey'">
              {{ item.public ? "mdi-eye" : "mdi-eye-off" }}
            </v-icon>
          </template>
          <template v-slot:item.audiences="{ item }">
            <v-chip
              v-for="audience in item.audiences || []"
              :key="audience.id"
              x-small
              label
              class="mr-1 mb-1"
            >
              {{ audience.name }}
            </v-chip>
          </template>
          <template v-slot:item.updatedAt="{ item }">
            {{
              item.updatedAt
                ? new Date(item.updatedAt).toLocaleDateString()
                : new Date(item.createdAt).toLocaleDateString()
            }}
          </template>
          <template v-slot:item.actions="{ item }">
            <v-icon small class="mr-2" @click="previewFeature(item)">
              mdi-eye
            </v-icon>
            <v-icon small class="mr-2" @click="openDialog(item)">
              mdi-pencil
            </v-icon>
            <v-icon small @click="removeFeature(item)">mdi-delete</v-icon>
          </template>
        </v-data-table>
      </div>
    </v-card>

    <FeatureDialog @success="loadFeatures" />
    <FeatureDisplay />
  </div>
</template>

<script>
import featuresService from "@/services/ultimate/features";
import FeatureDialog from "@/components/ultimate/feature/FeatureDialog.vue";
import FeatureDisplay from "@/components/ultimate/feature/FeatureDisplay.vue";
import { FEATURE_STATUSES } from "@/utils/featureUtils";

export default {
  name: "Features",
  components: { FeatureDialog, FeatureDisplay },
  metaInfo: { title: "Funcionalidades" },
  data() {
    return {
      loading: false,
      error: null,
      search: "",
      features: [],
      headers: [
        { text: "Título", value: "title" },
        { text: "Slug", value: "slug" },
        { text: "Status", value: "status" },
        { text: "Pública", value: "public" },
        { text: "Públicos-alvo", value: "audiences", sortable: false },
        { text: "Atualizado em", value: "updatedAt" },
        { text: "Ações", value: "actions", sortable: false },
      ],
    };
  },
  methods: {
    statusText(status) {
      return FEATURE_STATUSES[status]?.text || status;
    },
    statusColor(status) {
      return FEATURE_STATUSES[status]?.color || "grey";
    },
    openDialog(feature = null) {
      this.$root.$emit("feature-modal", feature);
    },
    previewFeature(feature) {
      this.$root.$emit("feature-display", feature);
    },
    async loadFeatures() {
      try {
        this.loading = true;
        this.error = null;
        const response = await featuresService.getAll();
        this.features = response.features || [];
      } catch (error) {
        this.error = error.message || "Erro ao buscar funcionalidades";
      } finally {
        this.loading = false;
      }
    },
    async removeFeature(feature) {
      if (!confirm(`Remover a funcionalidade "${feature.title}"?`)) return;
      try {
        await featuresService.remove(feature.id);
        await this.loadFeatures();
      } catch (error) {
        this.error = error.message || "Erro ao remover funcionalidade";
      }
    },
  },
  mounted() {
    this.loadFeatures();
  },
};
</script>
